import { useEffect } from "react";

import { SingleSelect } from "ui-components/Select";

import DataFileTypesModal from "modules/data-files/elements/Data-File-Types-Modal";
import { useGetTypesForFile } from "modules/data-files/api";

import { useGetInputFile, useOutcome } from "./store";

const ContinousOutcomeSelector = () => {
  const currentFile = useGetInputFile() || "";
  const [currentOutcome, setOutcome] = useOutcome();

  const types = useGetTypesForFile(currentFile);

  const colType = types[currentOutcome];

  useEffect(() => {
    if (currentOutcome && colType && colType !== "numeric") {
      setOutcome(null);
    }
  }, [currentOutcome, colType, setOutcome]);

  const options = Object.keys(types || {})
    .filter((v) => types?.[v] === "numeric")
    .sort();

  return (
    <div className="flex">
      <div className="w-1/4">
        <p className="font-bold">
          2. Select the Column you want to analyse drivers for:
        </p>
      </div>
      <div className="w-full">
        <SingleSelect<string>
          name="yVariables"
          allowedValues={options}
          selected={currentOutcome}
          onChange={setOutcome}
          placeholder="Select the Outcome Variable"
          help={
            <div>
              Dont see your variable of interest here? You can only choose{" "}
              <span className="font-semibold italic">
                numeric variables as outcomes.
              </span>{" "}
              <DataFileTypesModal
                as="span"
                modalClickElem={
                  <span className="text-primary-main underline cursor-pointer">
                    Click here
                  </span>
                }
                fileId={currentFile as string}
                enableDrop
              />{" "}
              to change column types in your data.
            </div>
          }
        />
      </div>
    </div>
  );
};

export default ContinousOutcomeSelector;
